import styled from "styled-components";

export const Form = styled.form`
  display: none;
  input {
    /* visibility: hidden; */
    /* display: none; */
  }
`;
